var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSideBySide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83334 3.5V16.5H8.16668V3.5H1.83334ZM1.66668 2.5C1.20644 2.5 0.833344 2.8731 0.833344 3.33333V16.6667C0.833344 17.1269 1.20644 17.5 1.66668 17.5H8.33334C8.79358 17.5 9.16668 17.1269 9.16668 16.6667V3.33333C9.16668 2.8731 8.79358 2.5 8.33334 2.5H1.66668Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 3.5V16.5H18.1667V3.5H11.8333ZM11.6667 2.5C11.2064 2.5 10.8333 2.8731 10.8333 3.33333V16.6667C10.8333 17.1269 11.2064 17.5 11.6667 17.5H18.3333C18.7936 17.5 19.1667 17.1269 19.1667 16.6667V3.33333C19.1667 2.8731 18.7936 2.5 18.3333 2.5H11.6667Z",
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSideBySide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side_by_side.3a2958ff1ac0b0f6b7090341fd8d9bde.svg";